<template>
  <div style="width: 100%; padding-right: 10px;">
    <div class="col-md-12" style="padding: 0; min-height: 63vh;">
      <a-spin :spinning="processing">
        <div style="padding: 30px;">

          <a-steps :current="currentTab" @change="changeTab">
            <a-step title="Step 1" description="Upload ZIP File" :disabled="currentTab == 2"/>
            <a-step title="Step 2" description="Review Details & Upload" :disabled="currentTab == 2"/>
            <a-step title="Upload Response" description="Successful Files & Error Messages" disabled="disabled"/>
          </a-steps>

          <br>

          <div v-if="currentTab == 0">
            <div class="tutorial">
              <b>
                Tutorial for Creating the ZIP file:
              </b>
              <br/>
              <ol type="1">
                <li>Move/Copy to a folder all the Sales JSON files you want to upload.</li>
                <li>Convert the folder with Sales JSON file into a ZIP file.</li>
                <li>Drag/Select the generated ZIP file into the upload area and click Next.</li>
              </ol>
            </div>
            <a-upload-dragger
              accept="application/zip,application/x-zip-compressed"
              :multiple="false"
              :remove="removeFile"
              :beforeUpload="beforeUpload"
              :fileList="file">
              <span class="fa fa-file-import" style="font: 20pt;" />
              <p class="ant-upload-text">Click or drag file to this area to upload</p>
              <p class="ant-upload-hint">
                Upload your zip file downloaded from HO.
              </p>
            </a-upload-dragger>
          </div>

          <br>

          <div v-if="currentTab == 1">
            <h6 class="text-muted">Upload Review</h6>
            <small>
              <div class="note">
                <b>Note: </b>
                <span>After clicking the Proceed Button, it will Upload the attached zip file and save all the json data.</span>
              </div>
            </small>

            <small>
                <b>Total Files:</b> {{totalFiles}}
            </small>
            <!-- <a-directory-tree multiple default-expand-all @select="onSelect" @expand="onExpand"> -->
            <div v-if="file.length > 0" style="margin-bottom: 20px;">
              <a-directory-tree multiple default-expand-all>
                <a-tree-node :key="zipFileName" :title="zipFileName">
                  <a-tree-node
                    v-for="dir in fileDirectories"
                    :key="dir"
                    :title="dir">
                    <a-tree-node
                      v-for="filename in fileTree[`${dir}`].children"
                      :key="filename"
                      :title="filename"
                      is-leaf />
                  </a-tree-node>
                </a-tree-node>
              </a-directory-tree>
            </div>
          </div>

          <div v-if="currentTab == 2">
            <small>
                <b>File Uploaded:</b> {{zipFileName}}
            </small>
            <br/>

            <div>
              <h6>Successful Files:</h6>
              <div v-if="successFiles.length > 0">
                <div v-for="fileName in successFiles">
                  <small>{{fileName}}</small>
                  <br/>
                </div>
              </div>
              <small v-else class="text-muted">No successful files</small>
            </div>

            <br/>

            <div>
              <h6>Errors:</h6>
              <div v-if="errorMsg.length > 0">
                <div v-for="msg in errorMsg">
                  <small>{{msg}}</small>
                  <br/>
                </div>
              </div>
              <small v-else>No error</small>
            </div>
          </div>

        </div>
      </a-spin>
    </div>

    <div class="col-md-12" style="position: absolute; bottom: 0px; width: 98%; background-color: #f2f2f2 ; padding: 10px;">
      <div class="steps-action float-right">
        <a-button v-if="currentTab > 0 && currentTab != 2"
                  :disabled="processing"
                  @click="prevStep">
          Previous
        </a-button>
        <a-button v-if="currentTab < maxStep"
                  type="primary"
                  style="margin-left: 8px"
                  :disabled="processing"
                  @click="nextStep">
          Next
        </a-button>
        <a-button v-if="currentTab == 1"
                  type="primary"
                  style="margin-left: 8px"
                  :disabled="processing"
                  @click.prevent="proceed">
          Proceed
        </a-button>
        <a-button v-if="currentTab == 2"
                  type="primary"
                  style="margin-left: 8px"
                  :disabled="processing"
                  @click.prevent="uploadAnother">
          Upload another File
        </a-button>
      </div>
    </div>
  </div>
</template>

<script>
import { mapState } from 'vuex';
import JSZip from 'jszip';
import HTTPRequest from '../../controllers/httpRequest.js';

export default {
  computed: {
    ...mapState(['serverType', 'endPoint'])
  },
  data() {
    return {
      successFiles: [],
      errorMsg: [],
      currentTab: 0,
      maxStep: 1,
      processing: false,
      file: [],
      zipFileName: '',
      fileDirectories: [],
      fileTree: {},
      totalFiles: 0
    }
  },
  methods: {
    renderNotification(type, msg, desc) {
      // DRY function for rendering notification
      this.$notification[type]({
        message: msg,
        description: desc
      });
    },
    resetFileData() {
      // Revert all file data into its default values
      this.successFiles = [];
      this.errorMsg = [];
      this.file = [];
      this.fileDirectories = [];
      this.fileTree = {};
      this.totalFiles = 0;
    },
    uploadAnother() {
      this.resetFileData();
      this.currentTab = 0
    },
    changeTab(currentTab) {
      // Check if form is processing
      if (this.processing) {
        this.renderNotification('error', 'Error', "Can't change tab while processing");
        return false;
      }

      // Prevent moving to review tab if file is empty
      if (currentTab == 1 && this.file.length == 0) {
        this.renderNotification('error', 'Upload Error', "Please attach a zip file.");
        return false;
      }

      this.currentTab = currentTab;
    },
    prevStep(){
      // Prevent moving to previous tab if form is processing
      if (this.processing) {
        this.renderNotification('error', 'Error', "Can't change tab while processing");
        return;
      }

      this.currentTab--;
    },
    nextStep(){
      // Prevent moving to review tab if file is empty
      if (this.currentTab == 0 && this.file.length == 0) {
        this.renderNotification('error', 'Upload Error', "Please attach a zip file.");
        return false;
      }

      this.currentTab++;
    },
    fileChildren() {

    },
    zipFileloop(zip) {
      for (const [_key, file] of Object.entries(zip.files)) {
        // Split file name with / then get the real file name
        const names = file.name.split("/");
        const filename = names[names.length - 1] || names[names.length - 2];

        if (file.dir) {
          // If file is a directory just push the file name into fileDirectories
          this.fileDirectories.push(filename);
        } else if (names.length > 1) {
          // If splited name is greater than 1
          if (this.fileTree[names[names.length - 2]]) {
            // Make file as child of the parent directory in fileTree
            this.fileTree[names[names.length - 2]].children.push(filename)
          } else {
            // Make a default object for parent directory in fileTree
            this.fileTree[names[names.length - 2]] = {}
            // Make file as child of the parent directory
            this.fileTree[names[names.length - 2]].children = [filename];
          }
          // Count total uploading files
          this.totalFiles++;
        }
      }
    },
    beforeUpload(file) {
      this.processing = true;

      let _this = this;
      this.resetFileData();

      // Check if file is zip file
      if (!['application/zip', 'application/x-zip-compressed'].includes(file.type)) {
        this.renderNotification('error', 'Upload Error', "Uploading file must be ZIP file");
        this.processing = false;
        return false;
      }

      // Set the zipFileName for file tree
      this.zipFileName = file.name;

      const reader = new FileReader();
      reader.onload = e => {
        this.file = [file];

        if (this.file.length > 0) {
          // If file exist load zip file to get all the file names of the uploading json files
          JSZip.loadAsync(file)
          .then(function(zip) {
            _this.zipFileloop(zip);
          })
        }
      }

      reader.readAsText(file);
      this.processing = false;
      return false;
    },
    removeFile() {
      this.resetFileData();
    },
    async proceed() {
      if (this.processing) { return; }
      this.processing = true;

      // Initialize form and append attached file
      let form = new FormData();
      form.append("file", this.file[0])

      // Send request to the server
      const request = await HTTPRequest.postRequest(`${this.endPoint}api_invoices/sales_uploader`, null, form);

      if (request.success) {
        this.renderNotification('success', 'Upload Done', 'Kindly check Upload Response for Successful files and Error messages');
        this.successFiles = request.success_files
        this.errorMsg = request.error_msg
        this.currentTab = 2;
      }

      this.processing = false;
    }
  }
}
</script>

<style scoped>
.note {
  font-style: italic;
  margin-top: 10px;
}
.tutorial {
  color: #333;
  font-size: 14px;
}
</style>
